var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasEntries
    ? _c(
        "div",
        { staticClass: "category-display", class: _vm.rootClasses },
        [
          _c(
            _vm.headProps.is,
            {
              tag: "component",
              staticClass: "u-reset category-display--head",
              attrs: { href: _vm.headProps.href }
            },
            [
              _c("div", { staticClass: "category-display--head-content" }, [
                _c("h2", { staticClass: "u-reset category-display--title" }, [
                  _vm._v(
                    "\n                " + _vm._s(_vm.title) + "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-display--arrow" },
                  [
                    _c("ui-icon", {
                      attrs: { symbol: "chevron-right", size: "small" }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "category-display--body" }, [
            _c(
              "ul",
              { staticClass: "u-reset category-display--entry-teasers" },
              _vm._l(_vm.entries, function(entry) {
                return _c(
                  "li",
                  {
                    key: entry.id,
                    staticClass: "category-display--entry-teaser"
                  },
                  [
                    _c(
                      "entry-teaser",
                      _vm._b(
                        {
                          attrs: {
                            "title-max-length": _vm.entryTitleMaxLength,
                            "parent-main-category-slug":
                              _vm.parentMainCategorySlug,
                            "parent-sub-category-slug":
                              _vm.parentSubCategorySlug,
                            facets: _vm.entryFacets
                          }
                        },
                        "entry-teaser",
                        entry,
                        false
                      )
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c7827d0", { render: render, staticRenderFns: staticRenderFns })
  }
}